export default "__VITE_ASSET__BuIjLegJ__"